import { Grid, Typography } from '@mui/material';
import React from 'react';
import { variants } from '../../../variants/variants';
import { FastfoodOutlined } from '@mui/icons-material';
import { useTheme } from '@emotion/react';
import NavbarLayout from '../../../common/NavbarLayout';
import { useNavigate } from 'react-router-dom';

const DelightsNavbar = () => {
  const theme = useTheme();
  const navigate = useNavigate()
  const handleNavigateBack = () => {
    navigate("/home")
  } 
  return (
    <NavbarLayout handleNavigate={handleNavigateBack}>
    <Grid item display={'flex'} justifyContent={'start'}>
      <FastfoodOutlined sx={variants.icon.active} />
      <Typography component={'div'} ml={1}>
        Delights{' '}
        <Typography
          sx={{
            fontSize: variants.BODY,
            [theme.breakpoints.down('lg')]: {
              fontSize: variants.TINY,
            },
          }}
        >
          Having a treat is not a bad idea
        </Typography>
      </Typography>
    </Grid>
    </NavbarLayout>
  );
};

export default DelightsNavbar;
